module.exports = __webpack_public_path__ + "5af31cd7ee047a7373098534231ad48c.MP3";